// extracted by mini-css-extract-plugin
export var benefitsSectionWrapper = "LifetimeBenefits-module--benefitsSectionWrapper---d1k5";
export var benefitsText = "LifetimeBenefits-module--benefitsText--r+uqW";
export var blogCard = "LifetimeBenefits-module--blogCard--QKKbN";
export var blogCardDetails = "LifetimeBenefits-module--blogCardDetails--G3Zf+";
export var blogCardImg = "LifetimeBenefits-module--blogCardImg--tKFSx";
export var blogCards = "LifetimeBenefits-module--blogCards---n5xb";
export var carousalButtongroup = "LifetimeBenefits-module--carousalButtongroup--8O9xO";
export var carouselHeading = "LifetimeBenefits-module--carouselHeading--+ZI7j";
export var disable = "LifetimeBenefits-module--disable--DIQWf";
export var facultyBenefitsList = "LifetimeBenefits-module--facultyBenefitsList--ttWg0";
export var facultyBenefitsListItem = "LifetimeBenefits-module--facultyBenefitsListItem--g6u7o";
export var facultyBenefitsWrapper = "LifetimeBenefits-module--facultyBenefitsWrapper--0IohG";
export var imgWrapper = "LifetimeBenefits-module--imgWrapper--1MGvM";
export var questionText = "LifetimeBenefits-module--questionText--qVhvs";